import {
  AgentProfileFilterKey,
  AgentProfileId,
  AgentProfilePublicDto,
  EtxeApiSlugs,
  ListPagination,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { QueryParamsUtils } from '../../../../../utils';

export class PublicAgentsConnector {
  private readonly slug = EtxeApiSlugs.AGENTS;

  constructor(
    private readonly apiCaller: ApiCaller,
    private readonly apiPrefix: string,
  ) {}

  get = (agentProfileId: AgentProfileId | string): Observable<AgentProfilePublicDto> =>
    this.apiCaller.getRequest<AgentProfilePublicDto>(this.apiPrefix, `${this.slug}/${agentProfileId}`);

  list = (pagination?: ListPagination<AgentProfileFilterKey>): Observable<AgentProfilePublicDto[]> =>
    this.apiCaller.getRequest<AgentProfilePublicDto[]>(
      this.apiPrefix,
      `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
    );

  count = (pagination?: ListPagination<AgentProfileFilterKey>): Observable<number> =>
    this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );
}
